"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mechanism = "serversync";
exports.serversync = (context) => {
    const createServerController = (publisher, _subscriber) => {
        let isRunning = false;
        const trigger = (...args) => {
            context.logger.debug(`trigger(${args.join(",")}`);
            const value = publisher(...args);
            context.logger.debug(`trigger TMessage: ${value}`);
        };
        const start = () => {
            context.logger.debug("serversync#start");
            isRunning = true;
        };
        const stop = () => {
            context.logger.debug("serversync#stop");
            isRunning = false;
        };
        return {
            start,
            stop,
            trigger,
            get isRunning() {
                return isRunning;
            },
            mechanism,
            isFallback: false,
            isServer: true,
            instanceID: "server"
        };
    };
    return createServerController;
};
//# sourceMappingURL=serversync.js.map